import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.desktop.shared.visit': {
         timeSinceLastVisit: {
            dayCount: {
               accusative: '{{count}} dzień',
               genitive: '{{count}} dni',
               plural: '{{count}} dni',
            },
            daysAgo: '{{days}} temu',
            lastDoctorVisit: 'Ostatnia wizyta lekarska w placówce: {{value}}',
            lastSamePractitionerVisit: 'Ostatnia wizyta u Ciebie: {{value}}',
            loadError: 'Nie udało się pobrać informacji o ostatniej wizycie pacjenta.',
            noVisit: '-',
            today: 'dziś',
         },
      },
   },
};

export const translationKeys = createScopedTranslationKeys(translations.pl, '~libs.desktop.shared.visit');
